import React from "react";
import { Separator } from "@/components/ui/separator";
export default function TermsOverview() {
  return <section data-section-id="154602" id="terms-of-service" className="relative flex min-h-[50vh] flex-col items-center justify-center overflow-hidden bg-secondary py-24 text-center md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-5 bg-[linear-gradient(to_right,rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:40px_40px]" />

      <div className="container relative z-10 mx-auto flex flex-col items-center px-4 md:px-6 backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl shadow-xl">
        <h1 className="mb-8 font-default text-4xl font-bold leading-tight tracking-tight text-primary md:text-5xl">
          Terms of Service
        </h1>

        <Separator className="mb-8 h-[2px] w-[80px] bg-primary" orientation="horizontal" />

        <p className="mx-auto max-w-[700px] font-sans text-base text-secondary-foreground/90 md:text-lg">
          Last Updated: October 2023. Please review the legal guidelines and 
          operational agreements that govern your engagement with our investment 
          platform and global financial services network.
        </p>
      </div>
    </section>;
}